/**
 * AR Technical Demo — shared one-shot "reveal" animation.
 *
 * THROWAWAY DEMO CODE. A single fly-in keyframe reused across the technical-demo
 * surfaces so freshly-appearing content (evidence rows on a thread, the agent's
 * reasoning steps, the Scene-2 reconciliation confirmation + flagged issues)
 * animates in consistently. Stagger siblings by setting an inline
 * `animationDelay`. Respects `prefers-reduced-motion`. Delete with src/demo/ar.
 *
 * Usage:
 *   <style>{evidenceStyles}</style>
 *   <div className="ar-tech-evidence-in" style={{ animationDelay: `${i * 140}ms` }} />
 */

/** CSS class applied to elements that should play the reveal animation. */
export const REVEAL_CLASS = 'ar-tech-evidence-in';

/** Inject once per surface via `<style>{evidenceStyles}</style>`. */
export const evidenceStyles = `
@keyframes ar-tech-evidence-in {
  from { opacity: 0; transform: translateY(14px) scale(0.94); }
  to { opacity: 1; transform: none; }
}
.ar-tech-evidence-in { animation: ar-tech-evidence-in 460ms cubic-bezier(0.22,1,0.36,1) both; }
@media (prefers-reduced-motion: reduce) {
  .ar-tech-evidence-in { animation: none; }
}
`;
